const dbShopBundle = require("../../../../shared/data/dbShopBundle.json");
const {modifyCart, addItemsToCart} = require("./CartUtil");
const {
	SubscriptionSkuEnum,
	BUNDLE_GRADE_PREFIX,
} = require("../../../../shared/StoreSkuUtil");
const {SUBSCRIPTION_CODE_SKU} = SubscriptionSkuEnum;

/**
 * Binds increment and decrement buttons to an input field to adjust its numeric value.
 *
 * @param {number} lvl - The level identifier used to select the corresponding input and buttons.
 * @returns {void} - side effects only.
 */
function tieButtonsToInput(addToCartButton) {
	const displayEl = document.querySelector(`#display-bundle-totals`);

	addToCartButton.addEventListener("click", () => {
		const calculatedTotal = calculateTotal();
		addMultipleBundlesWithSubCodesToCart(calculatedTotal);
	});

	return function(lvl) {
		const input = document.querySelector(`#bundle-input-lvl${lvl}`);
		const incButton = document.querySelector(`#bundle-increment-lvl${lvl}`);
		const decButton = document.querySelector(`#bundle-decrement-lvl${lvl}`);

		incButton.addEventListener("click", () => {
			input.value = parseInt(input.value) + 1;
			displayTotals(calculateTotal(), displayEl, addToCartButton);
		});
		decButton.addEventListener("click", () => {
			if (parseInt(input.value) > 0) {
				input.value = parseInt(input.value) - 1;
			}
			displayTotals(calculateTotal(), displayEl, addToCartButton);
		});
	};
}
/**
 * Calculate the total cost of the bundle
 * @returns {Array<[number, number]>} An array of arrays containing the level and the quantity
 */
function calculateTotal() {
	return [1, 2, 3, 4, 5].map(lvl => {
		const input = document.querySelector(`#bundle-input-lvl${lvl}`);
		return [lvl, parseInt(input.value)];
	});
}

function displayTotals(totals, displayEl, addToCartButton) {
	const totalSubCodes = totals.reduce((acc, [_lvl, qty]) => acc + qty, 0);
	if (totalSubCodes > 0) {
		addToCartButton.disabled = false;
		addToCartButton.classList.remove("disabled");
	}
	if (totalSubCodes < 1) {
		addToCartButton.disabled = true;
		addToCartButton.classList.add("disabled");
		displayEl.innerHTML = `<p>No items selected</p>`;
		return;
	}
	const subscriptionLine = `<p>Total Subscription Codes: ${totalSubCodes}</p>`;
	const makeBundleHTML = (lvl, qty) =>
		`<p>Level ${lvl} Book Set${qty > 1 ? "s" : ""}: ${qty}</p>`;
	const html = [
		subscriptionLine,
		...totals
			.filter(([lvl, qty]) => qty > 0)
			.map(([lvl, qty]) => makeBundleHTML(lvl, qty)),
	].join("");
	displayEl.innerHTML = html;
}

function handleClassWalletBundleModal() {
	const addToCartButton = document.getElementById(
		"classwallet-bundle-add-to-cart"
	);
	window.calculateTotal = calculateTotal;
	if (addToCartButton)
		[1, 2, 3, 4, 5].forEach(tieButtonsToInput(addToCartButton));
}

function getAllCodeBundleItems(bundleID, quantity = 1) {
	const skus = dbShopBundle[bundleID].skus;
	const items = skus.map(sku => {
		return {
			sku,
			quantity: quantity,
			options: {
				bundleID: bundleID,
			},
		};
	});
	return items;
}

function addMultipleBundlesWithSubCodesToCart(calculatedTotal) {
	const itemsToAdd = calculatedTotal
		.filter(([_lvl, qty]) => qty > 0)
		.flatMap(([lvl, qty]) => {
			return getAllCodeBundleItems(
				`${BUNDLE_GRADE_PREFIX}${lvl}-${SUBSCRIPTION_CODE_SKU}`,
				qty
			);
		});
	modifyCart(c => addItemsToCart(itemsToAdd, c));
}

module.exports = handleClassWalletBundleModal;
